import { apiSlice } from "./apiSlice";
import { ADMIN_URL } from "../constants";

const adminApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createAdmin: builder.mutation({
      query: (data) => ({
        url: `${ADMIN_URL}/createAdmin`,
        method: "POST",
        body: data,
        headers: {
          Authorization: `Bearer ${data.token}`,
        },
      }),
    }),
    getAdminById: builder.query({
      query: (data) => ({
        url: `${ADMIN_URL}/getAdmin/${data.adminId}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${data?.token}`,
        },
      }),
    }),
    updateAdmin: builder.mutation({
      query: (data) => ({
        url: `${ADMIN_URL}/editAdmin/${data._id}`,
        method: "PUT",
        body: data,
        headers: {
          Authorization: `Bearer ${data.token}`,
        },
      }),
    }),
    getAllAdmins: builder.query({
      query: (data) => ({
        url: `${ADMIN_URL}/getAllAdmins`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${data?.token}`,
        },
      }),
    }),
    adminLogin: builder.mutation({
      query: (data) => ({
        url: `${ADMIN_URL}/adminsLogin`,
        method: "POST",
        body: data,
      }),
    }),
    adminLogout: builder.mutation({
      query: (data) => ({
        url: `${ADMIN_URL}/adminLogout`,
        method: "POST",
        // body: data,
      }),
    }),
    addAdminToOutlet: builder.mutation({
      query: (data) => ({
        url: `${ADMIN_URL}/addAdminToOutlet`,
        method: "POST",
        body: data,
        headers: {
          Authorization: `Bearer ${data.token}`,
        },
      }),
    }),
    selectOutlet: builder.mutation({
      query: (data) => ({
        url: `${ADMIN_URL}/selectOutlet`,
        method: "PUT",
        body: data,
        headers: {
          Authorization: `Bearer ${data.token}`,
        },
      }),
    }),
  }),
});

export const {
  useCreateAdminMutation,
  useGetAdminByIdQuery,
  useGetAllAdminsQuery,
  useAdminLoginMutation,
  useUpdateAdminMutation,
  useAddAdminToOutletMutation,
  useAdminLogoutMutation,
  useSelectOutletMutation,
} = adminApiSlice;
